/**
 * Browser polyfills that must run before any other module evaluates.
 *
 * `casbin` (our RBAC enforcer) is authored for Node and references the global
 * `Buffer` at module-eval time. In the browser that global doesn't exist, so
 * without this shim the first module to pull in casbin throws
 * `ReferenceError: Buffer is not defined` and crashes the whole app.
 *
 * This file is imported as the FIRST statement in `main.tsx` so the global is
 * installed before the route tree (and therefore casbin) is evaluated.
 */
import { Buffer } from 'buffer';

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}
